import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import SectionReveal from "./SectionReveal";

const BANNER =
  "https://customer-assets.emergentagent.com/job_vespa-basel-relaunch/artifacts/bbyn0hev_imgi_1_Banner_Zubehoer.png";

const CATEGORIES = [
  {
    label: "Helme",
    desc: "Eleganz für den Kopf. Vintage-Look, modernste Sicherheit.",
    tone: "bg-[var(--cream-alt)]",
  },
  {
    label: "Kleidung",
    desc: "Vespa-Lederjacken, Tücher, T-Shirts — der Look fürs Leben.",
    tone: "bg-[#e8efe9]",
  },
  {
    label: "Merchandising",
    desc: "Original Memorabilia von der Marke, die alles begonnen hat.",
    tone: "bg-[#f1ece4]",
  },
  {
    label: "Tech-Zubehör",
    desc: "Topcase, Beinschutz, Auspuff­anlagen — funktional & ästhetisch.",
    tone: "bg-[var(--cream-alt)]",
  },
];

export default function Accessories() {
  return (
    <section
      id="zubehoer"
      className="section relative bg-[var(--cream)] overflow-hidden"
      data-testid="accessories-section"
    >
      <div className="container-wide">
        <div className="grid lg:grid-cols-12 gap-8 mb-16">
          <SectionReveal className="lg:col-span-7">
            <span className="overline">Il Lusso della Vespa</span>
            <h2 className="h-display text-5xl md:text-6xl lg:text-7xl mt-6 text-[var(--anthracite)]">
              Zubehör <span className="italic-accent text-[var(--sage-dark)]">Deluxe.</span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-[var(--muted-fg)] max-w-lg leading-relaxed">
              Das Luxus-Upgrade für Ihren Auftritt. Hochwertiges Leder, italienische
              Handwerkskunst, exklusive Editionen.
            </p>
          </SectionReveal>
          <SectionReveal delay={1} className="lg:col-span-5 self-end">
            <p className="font-serif italic text-2xl md:text-3xl text-[var(--anthracite)] leading-tight max-w-sm">
              "Vespa ist nicht, was du fährst. Es ist, wer du bist."
            </p>
          </SectionReveal>
        </div>

        {/* Editorial banner */}
        <SectionReveal className="relative mb-16 overflow-hidden">
          <div className="relative aspect-[21/9] w-full overflow-hidden bg-[#0d1a2e]">
            <motion.img
              src={BANNER}
              alt="Vespa Zubehör Premium-Leder"
              loading="lazy"
              initial={{ scale: 1.1 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/10 to-transparent" />
            <div className="absolute inset-0 flex flex-col justify-center p-8 md:p-16">
              <span className="overline !text-white/80">Edition · Cuoio Premium</span>
              <h3 className="font-serif text-4xl md:text-6xl lg:text-7xl mt-4 text-white tracking-tightest max-w-[14ch] leading-[0.95]">
                Handgefertigtes <span className="italic-accent">Leder.</span>
              </h3>
              <p className="mt-6 text-white/80 max-w-md leading-relaxed">
                Sitzbänke und Topcases aus echtem Cuoio-Leder — eine Hommage an die
                italienische Lederkunst.
              </p>
            </div>
          </div>
        </SectionReveal>

        {/* Category grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {CATEGORIES.map((c, i) => (
            <SectionReveal key={c.label} delay={i}>
              <motion.div
                whileHover={{ y: -4 }}
                className={`group ${c.tone} aspect-[3/4] relative card-clean overflow-hidden`}
                data-testid={`accessory-cat-${c.label.toLowerCase()}`}
              >
              <Link to="/casa-markus" className="block w-full h-full p-8">
                <div className="grain absolute inset-0" />
                <div className="relative flex flex-col h-full justify-between">
                  <span className="font-serif text-5xl md:text-6xl text-[var(--sage-dark)]/30 leading-none">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h4 className="font-serif text-3xl md:text-4xl text-[var(--anthracite)] mb-3 leading-tight">
                      {c.label}
                    </h4>
                    <p className="text-sm text-[var(--muted-fg)] leading-relaxed">
                      {c.desc}
                    </p>
                    <span className="inline-flex items-center gap-2 mt-6 text-[10px] uppercase tracking-[0.22em] text-[var(--anthracite)] group-hover:text-[var(--sage-dark)] transition-colors">
                      Anfragen <ArrowUpRight size={12} strokeWidth={1.5} />
                    </span>
                  </div>
                </div>
              </Link>
              </motion.div>
            </SectionReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
